import { defineComponent as _defineComponent } from 'vue'
import {
  IMonthly,
  IPerformanceHistorical
} from '@/modules/investments/types/Performance';
import PerformanceByYear from '@/modules/investments/views/Performance/components/PerformanceHistorical/components/PerformanceByYear/PerformanceByYear.vue';
import PerformanceDetail from '@/modules/investments/views/Performance/components/PerformanceHistorical/components/PerformanceDetail/PerformanceDetail.vue';
import { SpinnerLoader } from '@warrenbrasil/nebraska-web';
import { ref } from 'vue';
interface Props {
  historical: IPerformanceHistorical;
  isLoading: boolean;
  benchmarkSelected: string;
  benchmarkComparisonSelected: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceHistorical',
  props: {
    historical: null,
    isLoading: { type: Boolean },
    benchmarkSelected: null,
    benchmarkComparisonSelected: null
  },
  setup(__props: any) {



const showModal = ref(false);
const details = ref();

const handleShowDetails = (value: IMonthly) => {
  showModal.value = true;
  details.value = value;
};

return { __sfc: true,showModal, details, handleShowDetails, PerformanceByYear, PerformanceDetail, SpinnerLoader }
}

})